<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Short Description <mat-icon (click)="openEditDescDialog()" class="edit-icon">edit</mat-icon></h2>
  </div>
  <div class="section__body">
    <div class="section__content event-desc__content" [innerHTML]="aviationEvent.shortDescription">
    </div>
  </div>
</div>
